import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// @LTG-ID: app-bootstrap
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 05_DEPENDENCIES.md (react-helmet-async), 08_FEATURES.md#F-050,
//        ORCH-0050 A2 (react-helmet-async for JSON-LD injection)
// @CHANGED: 2026-02 session_004 (CHG-0060)
// @OWNER: web
//
// HelmetProvider wraps the entire tree so any descendant route can inject
// <head> tags (JSON-LD Article schema, canonical, page-specific meta) via
// react-helmet-async. Required for F-050 Brief 01's Article schema; will be
// reused by F-051 Brief 02 (P3-M3) and the Journals index (P3-M4).
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </React.StrictMode>,
);
